const Profile = () => import(/*webpackChunkName: 'profile'*/ '../views/Profile.vue');
const ProfileOverview = () => import(/*webpackChunkName: 'profile'*/ '@/components/profile/overview/Profile.vue');
const ProfileMorningMonitoring = () =>
    import(/*webpackChunkName: 'profile'*/ '@/components/profile/morning-monitoring/MorningMonitoringContent.vue');
const ProfileNotes = () => import(/*webpackChunkName: 'profile'*/ '@/components/profile/notes/ProfileNotes.vue');
const ProfileDrv = () => import(/*webpackChunkName: 'profile'*/ '@/components/profile/drv/ProfileDrv.vue');
const ProfileErgoReport = () =>
    import(/*webpackChunkName: 'profile'*/ '@/components/profile/ergo-report/ErgoReport.vue');
const ProfileRowingReport = () =>
    import(/*webpackChunkName: 'profile'*/ '@/components/profile/rowing-report/RowingReport.vue');
const ProfileSettings = () =>
    import(/*webpackChunkName: 'profile'*/ '@/components/profile/settings/ProfileSettings.vue');

import {
    ROUTES_PROFILE,
    ROUTES_PROFILE_DRV,
    ROUTES_PROFILE_ERGO_REPORT,
    ROUTES_PROFILE_MORNING_MONITORING,
    ROUTES_PROFILE_NOTES,
    ROUTES_PROFILE_OVERVIEW,
    ROUTES_PROFILE_ROWING_REPORT,
    ROUTES_PROFILE_SETTINGS
} from '@/constants/routes';

export default {
    path: '/profile',
    name: ROUTES_PROFILE,
    component: Profile,
    redirect: { name: ROUTES_PROFILE_OVERVIEW },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    children: [
        {
            path: '/profile/:id',
            name: ROUTES_PROFILE_OVERVIEW,
            component: ProfileOverview,
            props: true
        },
        {
            path: '/profile/morning-monitoring/:id',
            name: ROUTES_PROFILE_MORNING_MONITORING,
            component: ProfileMorningMonitoring,
            props: true
        },
        {
            path: '/profile/notes/:id',
            name: ROUTES_PROFILE_NOTES,
            component: ProfileNotes,
            props: false
        },
        {
            path: '/profile/drv/:id',
            name: ROUTES_PROFILE_DRV,
            component: ProfileDrv,
            props: true
        },
        {
            path: '/profile/ergo-report/:id',
            name: ROUTES_PROFILE_ERGO_REPORT,
            component: ProfileErgoReport,
            props: true
        },
        {
            path: '/profile/rowing-report/:id',
            name: ROUTES_PROFILE_ROWING_REPORT,
            component: ProfileRowingReport,
            props: true
        },
        {
            path: '/profile/settings/:id',
            name: ROUTES_PROFILE_SETTINGS,
            component: ProfileSettings,
            props: true
        }
    ]
};
